import { Button, TooltipDialog } from "@newsela/angelou";

import { withTrackEvent, objectTypes, actionNames } from "@newsela/snitch";
import InfoIcon from "@/icons/InfoIcon";

import {
  toolTipCss,
  toolTipIconCss,
  toolTipWrapperCss,
} from "./EcoModeToolTipDialog.style";

const TooltipDialogWithTrackEvent = withTrackEvent(TooltipDialog);

interface IEcoModeTooltipDialog {
  currentContentLevelId: string;
}

const TOOLTIP_COPY =
  "Save ink and paper by excluding images and consolidating text with activities.";

const EcoModeTooltipDialog = ({
  currentContentLevelId,
}: IEcoModeTooltipDialog) => {
  return (
    <TooltipDialogWithTrackEvent
      __cssFor={toolTipCss}
      ariaProps={{ "aria-label": TOOLTIP_COPY }}
      body={<div css={toolTipWrapperCss}>{TOOLTIP_COPY}</div>}
      // @ts-expect-error Property 'css' does not exist on type
      buttonContents={<InfoIcon css={toolTipIconCss} />}
      buttonProps={{ flavor: Button.flavors.incognito }}
      dataProps={{ "data-qa-selector": "print-eco-mode-tool-tip-dialog" }}
      dialogAriaProps={{
        "aria-label": "More information on printing with eco-friendly mode.",
      }}
      placement="top"
      // tracking props
      objectType={objectTypes.content}
      actionName={actionNames.print}
      streamProperties={{
        content_id: currentContentLevelId,
        content_type: "Article",
        description: "Open print options eco-friendly mode tooltip",
      }}
    />
  );
};

export default EcoModeTooltipDialog;
